import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_2 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, " ID ", -1 /* HOISTED */)
const _hoisted_4 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_5 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_6 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_7 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_8 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_9 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, " Status ", -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
}, null, -1 /* HOISTED */)
const _hoisted_12 = { class: "linked" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "d-flex align-items-center justify-content-start" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  "data-bs-title": "Tooltip on top",
  class: "d-flex align-items-center justify-content-center icon text-warning",
  "data-content": "This user has requested erasure"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-receipt-x" }, null, -1 /* HOISTED */)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center icon text-success"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-check-fat" }, null, -1 /* HOISTED */)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end" }
const _hoisted_29 = { class: "dropdown position-static" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "data-bs-boundary": "viewport"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1 /* HOISTED */)
const _hoisted_31 = { class: "dropdown-menu" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-eye lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pencil lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "spinner-border spinner-border-xs border-1 me-8",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_36 = {
  key: 1,
  class: "ph ph-arrow-clockwise lh-1 me-8 position-relative top-1"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TablePagination = _resolveComponent("TablePagination")!
  const _component_AlertModal = _resolveComponent("AlertModal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_ctx.users === undefined)
        ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
            key: 0,
            class: "mt-50"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("table", _hoisted_2, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_3,
                  _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('form.first_name.label')), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('form.last_name.label')), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('form.role.label')), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('form.role_in_department.label')), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('form.email.label')), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('form.phone.label')), 1 /* TEXT */),
                  _hoisted_10,
                  _hoisted_11
                ])
              ]),
              _createElementVNode("tbody", _hoisted_12, [
                _createCommentVNode(" PATIENT ROW "),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: user.id
                  }, [
                    _createElementVNode("th", {
                      class: "shadow-none lh-1 fw-medium text-body-tertiary title",
                      onClick: ($event: any) => (_ctx.show(user))
                    }, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(user.id), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_13),
                    _createElementVNode("td", {
                      class: "shadow-none lh-1 fw-medium text-body-tertiary",
                      onClick: ($event: any) => (_ctx.show(user))
                    }, _toDisplayString(user.firstname), 9 /* TEXT, PROPS */, _hoisted_15),
                    _createElementVNode("td", {
                      class: "shadow-none lh-1 fw-medium text-body-tertiary",
                      onClick: ($event: any) => (_ctx.show(user))
                    }, _toDisplayString(user.lastname), 9 /* TEXT, PROPS */, _hoisted_16),
                    _createElementVNode("td", {
                      class: "shadow-none lh-1 fw-medium text-black-emphasis",
                      onClick: ($event: any) => (_ctx.show(user))
                    }, _toDisplayString(user.role.name), 9 /* TEXT, PROPS */, _hoisted_17),
                    _createElementVNode("td", {
                      class: "shadow-none lh-1 fw-medium text-body-tertiary",
                      onClick: ($event: any) => (_ctx.show(user))
                    }, _toDisplayString(user.role_in_department), 9 /* TEXT, PROPS */, _hoisted_18),
                    _createElementVNode("td", {
                      class: "shadow-none lh-1 fw-medium text-primary",
                      onClick: ($event: any) => (_ctx.show(user))
                    }, _toDisplayString(user.email), 9 /* TEXT, PROPS */, _hoisted_19),
                    _createElementVNode("td", {
                      class: "shadow-none lh-1 fw-medium text-body-tertiary",
                      onClick: ($event: any) => (_ctx.show(user))
                    }, _toDisplayString(user.phone_number), 9 /* TEXT, PROPS */, _hoisted_20),
                    _createElementVNode("td", {
                      class: "shadow-none lh-1 fw-medium text-body-tertiary",
                      onClick: ($event: any) => (_ctx.show(user))
                    }, [
                      (user.has_requested_erasure)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_22, [..._hoisted_24]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_25, [..._hoisted_27]))
                    ], 8 /* PROPS */, _hoisted_21),
                    _createElementVNode("td", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("ul", _hoisted_31, [
                          _createElementVNode("li", null, [
                            _createVNode(_component_router_link, {
                              to: {
                                            path: `/user/${user.id}`, query: {
                                                center_id: _ctx.center_id
                                            }
                                        },
                              class: "dropdown-item d-flex align-items-center"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_32,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.view')), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_router_link, {
                              to: { path: `/user/${user.id}/edit`, query: { center_id: _ctx.center_id } },
                              class: "dropdown-item d-flex align-items-center"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_33,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.edit')), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item d-flex align-items-center",
                              onClick: (e) => _ctx.recoveryPassword(user, e)
                            }, [
                              (_ctx.recovery_loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_35))
                                : (_openBlock(), _createElementBlock("i", _hoisted_36)),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.recovery_password')), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_34)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item d-flex align-items-center",
                              onClick: ($event: any) => (_ctx.confirmDeleteUser(user))
                            }, [
                              _hoisted_38,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.delete')), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_37)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])),
      _createCommentVNode(" PAGINATION "),
      _createVNode(_component_TablePagination, {
        count: _ctx.users?.length ?? 0,
        page: _ctx.currentPage,
        total: _ctx.totalUsers,
        pages: _ctx.lastPage,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setPage($event)))
      }, null, 8 /* PROPS */, ["count", "page", "total", "pages"])
    ]),
    _createVNode(_component_AlertModal, {
      id: "recovery_modal",
      title: _ctx.$t('feature.auth.$recovery_user_password.title'),
      message: _ctx.recovery_modal_message
    }, null, 8 /* PROPS */, ["title", "message"]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteUser())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}